import { linkResolver } from "utils/LinkResolver";

export const repositoryConfig = [
  {
    repositoryName: process.env.GATSBY_PRISMIC_REPO,
    linkResolver,
  },
];
